import settings from "../../../../constants/settings";
import useFetchAndTrace from "../../fetchWithTrace";
import { useCallback } from "react";
import { Board } from "../../../../reducers/uploadedBoard";
import { useCustomAlert } from "../../alerts";

export default function useDownloadBOMFile() {
  const customAlert = useCustomAlert();
  const fetchAndTrace = useFetchAndTrace();

  const errorHandler = useCallback(() => {
    customAlert("Failed to download BOM");
  }, [customAlert]);

  return useCallback(
    (board: Board) => {
      const loadBOMHandler = async (response: Response) => {
        if (response.ok) {
          const blob = await response.blob();
          const link = document.createElement("a");
          link.download = `${board.project_name}-${board.id}-BOM.xlsx`;
          link.href = URL.createObjectURL(blob);
          link.click();
        } else {
          throw Error("Failed to get BOM");
        }
      };

      void fetchAndTrace(
        `${settings.api_url}/boards/${board.id}/BOM`,
        loadBOMHandler,
        errorHandler,
      );
    },
    [errorHandler, fetchAndTrace],
  );
}
